export const processHeading = 'Our Process';
export const processQuestions = ['Should we enter this market?', 'Who will pay?', 'What should we charge?', 'Why isn’t this growing?'];
export const processFollowUp = 'We work alongside founders and their teams to answer questions like these. Engagements follow our four-step methodology:';
export const processSteps = [{
  n: '01',
  title: 'Frame.',
  lead: 'Find the problem underneath the problem.',
  body: 'We talk to customers, examine the economics, and test assumptions behind the question.'
}, {
  n: '02',
  title: 'Decide.',
  lead: 'Work out what the evidence supports, commit to a direction.',
  body: 'We test demand with prototypes and model what each path would earn, so decisions sit on evidence and commercial judgment.'
}, {
  n: '03',
  title: 'Build.',
  lead: 'Put decisions into practice.',
  body: 'We build go-to-market, pricing, and revenue operations systems, implementing AI where it materially improves the outcome.'
}, {
  n: '04',
  title: 'Scale.',
  lead: 'Make the work part of how the business runs.',
  body: 'We partner with Product, Finance, Marketing, Engineering and Sales to set operating rhythms that keep systems improving as the company grows.'
}];

/**
 * One sentence, set as three descending clauses: top, middle, ground.
 * Each clause is split into phrases; on phones every phrase starts a new line, on larger screens they run together.
 */
export const processClosing = [['We report to the top,'], ['lead across functions', 'in the middle,'], ['and stay close to', 'execution on the ground.']];